/**
 * CONNOX GMBH CONFIDENTIAL
 * ________________________
 *
 * Copyright (c) 2005 - 2018 Connox GmbH, All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property
 * of Connox GmbH and its suppliers, if any. The intellectual and
 * technical concepts contained herein are proprietary to Connox GmbH and
 * its suppliers and may be covered by German Laws and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is
 * strictly forbidden unless prior written permission is obtained from
 * Connox GmbH.
 */

import {IWishlistData, IWishlistItem, WishlistRequestHandler} from "./requestHandler/WishlistRequestHandler";
import {IEventEmitter} from "../events/IEventEmitter";
import {EventEmitter} from "../events/EventEmitter";

export class Wishlist {
  private wishlistData: IWishlistData;
  private readonly eventEmitter: IEventEmitter<IWishlistData>;
  private readonly shopId: number;
  private readonly visitorId: string;
  private readonly currencyCode: string;

  constructor(shopId: number, currencyCode: string, visitorId: string, wishlistData: IWishlistData) {
    this.shopId = shopId;
    this.visitorId = visitorId;
    this.currencyCode = currencyCode;
    this.wishlistData = wishlistData;
    this.eventEmitter = new EventEmitter<IWishlistData>();

    this.eventEmitter.on((payload) => {
      if (payload === this.wishlistData) {
        return;
      }
      this.wishlistData = payload;
    });

    this.addItem = this.addItem.bind(this) as (itemId: number) => Promise<void>;
    this.deleteItem = this.deleteItem.bind(this) as (itemId: number) => Promise<void>;
  }

  public get items(): IWishlistItem[] {
    return this.wishlistData.items;
  }

  public get id(): string {
    return this.wishlistData.id;
  }

  public get modified(): string {
    return this.wishlistData.modified;
  }

  public get emitter(): IEventEmitter<IWishlistData> {
    return this.eventEmitter;
  }

  /**
   * Add item to wishlist
   * @param itemId
   */
  public async addItem(this: Wishlist, itemId: number): Promise<void> {
    this.wishlistData = await WishlistRequestHandler.postWishlistItem(
      this.shopId,
      this.currencyCode,
      this.visitorId,
      itemId,
    );
    this.eventEmitter.emit(this.wishlistData);
  }

  /**
   * Delete item from wishlist
   * @param itemId
   */
  public async deleteItem(this: Wishlist, itemId: number): Promise<void> {
    this.wishlistData = await WishlistRequestHandler.deleteWishlistItem(
      this.shopId,
      this.currencyCode,
      this.visitorId,
      this.id,
      itemId,
    );
    this.eventEmitter.emit(this.wishlistData);
  }
}
